import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  StickyNote,
  FileText,
  BarChart3,
  MessageSquare,
  Bell,
  Settings,
  Zap,
} from 'lucide-react'
import { cn } from '@/lib/utils'

const navItems = [
  { to: '/app/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/app/notes', icon: StickyNote, label: 'Notes' },
  { to: '/app/forms', icon: FileText, label: 'Forms' },
  { to: '/app/polls', icon: BarChart3, label: 'Polls' },
  { to: '/app/feedback', icon: MessageSquare, label: 'Feedback' },
  { to: '/app/notifications', icon: Bell, label: 'Notifications' },
  { to: '/app/billing', icon: Zap, label: 'Billing' },
  { to: '/app/settings', icon: Settings, label: 'Settings' },
]

export function Sidebar() {
  return (
    <aside className="hidden md:flex h-screen w-64 flex-col border-r bg-sidebar">
      <div className="flex h-14 items-center border-b px-4">
        <img src="/icons/quikee.svg" alt="Quikee" width="108" height="28" className="h-7" />
      </div>
      <nav className="flex-1 space-y-1 p-3">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-sidebar-accent text-sidebar-accent-foreground'
                  : 'text-sidebar-foreground/70 hover:bg-sidebar-accent/50 hover:text-sidebar-foreground',
              )
            }
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  )
}
